var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"left-box"},[_c('el-image',{staticClass:"logo-image",attrs:{"src":_vm.logoImage}}),_c('loginAccount')],1),_c('div',{staticClass:"right-box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }